// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"d5a48c4b","180":"393888ea","225":"8969fe63","239":"44ee70aa","331":"ebf59e5c","409":"263cbc62","416":"15c19c69","449":"064b6289","472":"7793842e","574":"064c38c2","591":"6014a69a","604":"8bd6a520","615":"f7d3c38f","647":"061bcb54","703":"92c8ff22","847":"3d054adf"}[chunkId] + ".chunk.js";
};